<!--
 * @Author: TinaHuang0183 
 * @Date: 2022-07-18 14:16:55
 * @LastEditors: TinaHuang0183 
 * @LastEditTime: 2022-07-22 14:42:14
 * @FilePath: /notion-widgets-site/src/views/Home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="home">
    <layouts><router-view></router-view></layouts>
  </div>
</template>

<script>
// @ is an alias to /src
import Layouts from "@/components/Layouts-v2.vue";
import FirstPanel from "@/components/home/FirstPanel.vue";

export default {
  name: "home",
  components: {
    Layouts,
    FirstPanel,
  },
};
</script>

<style lang="less" scoped>
// .home {
//   min-height: 100vh;
// }
</style>
